import { SplitPanel } from '@infotech-soe/erp-ui-kit';
import React from 'react';

import { TPaneSign, TTreeId } from '../../../models/role-privs/RolePrivsData';

import TreeWithActions from './PrivsTreeWithActions';

interface PrivsPaneProps {
  mainTreeId?: TTreeId;
  categoryTreeId: TTreeId;
  name: TPaneSign;
  label: string;
}

const PrivsPane: React.FC<PrivsPaneProps> = ({
  mainTreeId,
  categoryTreeId,
  name,
}) => {
  if (name === 'all') {
    return (
      <TreeWithActions treeId={categoryTreeId} pane={name} isCategoryTree />
    );
  } else {
    return (
      <SplitPanel horizontal>
        <TreeWithActions
          treeId={mainTreeId}
          pane={name}
          withoutActions={name !== 'catalog'}
        />
        <TreeWithActions treeId={categoryTreeId} pane={name} isCategoryTree />
      </SplitPanel>
    );
  }
};

export default React.memo(PrivsPane);
